import React from 'react';
import PropTypes from 'prop-types';
import GaugeChart from 'react-gauge-chart';
import './GaugeChart.css';

const DEFAULT_COLORS = ['#FF0000', '#FFA500', '#FFFF00', '#00FF00'];

const DEFAULT_ARCS_LENGTH = [0.35, 0.25, 0.15, 0.25];

const formatPercent = (part, whole) =>
  whole > 0 ? `${((part / whole) * 100).toFixed(1)}%` : '0%';

const SummaryGauge = ({
  id,
  title,
  value1,
  value2,
  unit,
  emptyLabel,
  legendFormatter,
  colors,
  arcsLength,
  loading,
}) => {
  const hasData = value1 > 0 || value2 >0;
  
  const total = value1 + value2
  
  const percent = hasData ? Math.min(Math.max(value1 / total, 0), 1) : 0;


  return (
    <div className="summary-gauge text-center">
      <table className="summary-gauge__table">
        <tbody>
          <tr>
            <td rowSpan={2} className="summary-gauge__table-sum">
              {total}
            </td>
            <td style={{ backgroundColor: '#c3e6cb' }}>{value1 || 0}</td>
            <td>{formatPercent(value1 || 0, total)}</td>
          </tr>
          <tr>
            <td style={{ backgroundColor: '#f8c76c' }}>{value2 || 0}</td>
            <td>{formatPercent(value2 || 0, total)}</td>
          </tr>
        </tbody>
      </table>
      {title && <h2 className="summary-gauge__title">{title}</h2>}

      <GaugeChart
        id={id}
        nrOfLevels={arcsLength.length}
        arcsLength={arcsLength}
        colors={colors}
        percent={percent}
        arcPadding={0.02}
        cornerRadius={3}
        textColor="#000000"
        animate={!loading}
        formatTextValue={() =>
          hasData ? `${(percent * 100).toFixed(1)}%` : emptyLabel
        }
      />

      <div className="summary-gauge__legend text-muted">
        {hasData ? legendFormatter(value1, total, unit) : emptyLabel}
      </div>
    </div>
  );
};

SummaryGauge.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  value1: PropTypes.number,
  value2: PropTypes.number,
  unit: PropTypes.string,
  emptyLabel: PropTypes.string,
  legendFormatter: PropTypes.func,
  colors: PropTypes.arrayOf(PropTypes.string),
  arcsLength: PropTypes.arrayOf(PropTypes.number),
  loading: PropTypes.bool,
};

SummaryGauge.defaultProps = {
  title: null,
  value1: 0,
  value2: 0,
  unit: 'día(s)',
  emptyLabel: 'Sin datos',
  legendFormatter: (value, total, unit) => `${value} de ${total} ${unit}`,
  colors: DEFAULT_COLORS,
  arcsLength: DEFAULT_ARCS_LENGTH,
  loading: false,
};

export default SummaryGauge;